import React from 'react'
import { Ad } from "../interface/Ad"
import AdView from './media/AdView'

interface AdControllerProps {
  ads: Ad[]
  defaultAdDuration: number // milliseconds
  didFinishCycle: Function
  show: boolean
  showOneAdPerCycle: boolean
  didFullyLoad: () => void
  debug: boolean
}

interface AdControllerState {
  adDurations: number[]
  currentIndex: number
  hasShown: boolean
  loadedCount: number
  updatedAt: number
}

export default class AdController extends React.Component<AdControllerProps, AdControllerState> {
  adTimer?: any

  constructor(props: AdControllerProps) {
    super(props)

    this.state = {
      adDurations: this.getInitialAdDurations(props.ads.length, props.defaultAdDuration),
      currentIndex: 0,
      hasShown: false,
      loadedCount: 0,
      updatedAt: Date.now()
    }
  }

  getInitialAdDurations(numberOfAds: number, defaultAdDuration: number): number[] {
    let durations = []
    for (let i = 0; i < numberOfAds; i++) {
      durations.push(defaultAdDuration)
    }
    return durations
  }

  componentDidUpdate(prevProps: AdControllerProps, _prevState: AdControllerState) {
    if (this.props.defaultAdDuration !== prevProps.defaultAdDuration) {
      let adDurations = [...this.state.adDurations]
      for (let i = 0; i < adDurations.length; i++) {
        if (adDurations[i] === prevProps.defaultAdDuration) {
          adDurations[i] = this.props.defaultAdDuration
        }
      }
      this.setState({ adDurations: adDurations })
    }

    if (this.props.show && !prevProps.show) {
      this.setState({ hasShown: true })

      if (this.props.showOneAdPerCycle) {
        this.playAd(this.getNextIndex(), false)
      } else {
        this.playAd(0)
      }
    }

    if (JSON.stringify(this.props.ads) !== JSON.stringify(prevProps.ads)) {

      this.setState({
        loadedCount: 0,
        adDurations: this.getInitialAdDurations(this.props.ads.length, this.props.defaultAdDuration),
        updatedAt: Date.now()
      })
    }
  }

  componentWillUnmount() {
    clearTimeout(this.adTimer)
  }

  getNextIndex(): number {
    if (this.state.currentIndex >= this.props.ads.length - 1) {
      return 0
    }
    return this.state.currentIndex + 1
  }

  playAd(index = 0, playAll = true) {
    if (index >= this.props.ads.length) {
      this.props.debug && console.log(`Will finish ads`)
      this.props.didFinishCycle()
      this.setState({ currentIndex: 0 })
      return
    }

    this.props.debug && console.log(`Play ad ${index}`)

    this.setState({ currentIndex: index },
      () => {
        if (playAll) {
          this.adTimer = setTimeout(() => this.playAd(index + 1), this.state.adDurations[index])
        } else {
          this.adTimer = setTimeout(this.props.didFinishCycle, this.state.adDurations[index])
        }
      })
  }

  setVideoAdDuration(duration: number, index: number) {
    let adDurations = [...this.state.adDurations]

    this.props.debug && console.log(`Update video ad duration to ${duration} at index ${index}`)

    adDurations[index] = duration * 1000
    this.setState({ adDurations: adDurations })
  }

  loadedAd() {
    this.props.debug && console.log(`Ad loaded #${this.state.loadedCount + 1}`)

    this.setState({ loadedCount: this.state.loadedCount + 1 },
      () => {
        if (this.state.loadedCount >= this.props.ads.length) {
          this.props.didFullyLoad()
        }
      })
  }

  render() {
    let animationClass = this.props.show ? "windmillShow" : "windmillHide"
    if (!this.state.hasShown) {
      animationClass = "hide"
    }

    return (
      <section id="slideContainer" className={animationClass}>
        {this.props.ads.map((ad, index) => (
          <AdView
            key={`${index}-${this.state.updatedAt}`}
            ad={ad}
            show={this.state.currentIndex === index && this.props.show}
            didLoad={() => this.loadedAd()}
            didMeasureVideoDuration={(duration: number) => this.setVideoAdDuration(duration, index)}
          />
        ))}
      </section>
    )
  }
}